mapboxgl.accessToken = 'pk.eyJ1IjoibWFwYm94c291bG9yaWdpbiIsImEiOiJjbWYzOTBhYW4wOXR1MnFxNXJrbDFqYjRxIn0.muIlWAt-du6TIKqVxWAbaw';

// const lang = 133.37753877679097, lat = -25.977297572783417

/**
 * Add the map to the page
 */
const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/streets-v11',
  center: [133.37753877679097, -25.977297572783417],
  zoom: 3.2,
  scrollZoom: true,
});

fetch('https://api.ipstack.com/check?access_key=c3bd7907943275d8ff7b0f58bf95c140')
  .then((response) => response.json())
  .then((json) => {
    const { latitude, longitude } = json;

    if (latitude && longitude) {
      map.setCenter([longitude, latitude]);
    }
  });

// const stores - defined in store-locator.liquid to use article metafields and be defined first
/**
 * Assign a unique id to each store. You'll use this `id`
 * later to associate each point on the map with a listing
 * in the sidebar.
 */
stores.features.forEach((store, i) => {
  store.properties.id = i;
});

/**
 * Wait until the map loads to make changes to the map.
 */
map.on('load', () => {
  /**
   * This is where your '.addLayer()' used to be, instead
   * add only the source without styling a layer
   */
  map.addSource('places', {
    type: 'geojson',
    data: stores,
  });

  /**
   * Create a new MapboxGeocoder instance.
   */
  const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    autocomplete: false,
    mapboxgl: mapboxgl,
    marker: true,
    bbox: [113.56979229907121, -41.584481052323, 154.39465662095077, -14.934727932306428],
  });

  /**
   * Add all the things to the page:
   * - The location listings on the side of the page
   * - The search box (MapboxGeocoder) onto the map
   * - The markers onto the map
   */
  buildLocationList(stores);
  document.getElementById('geocoder').appendChild(geocoder.onAdd(map));

  addMarkers();

  /**
   * Listen for when a geocoder result is returned. When one is returned:
   * - Calculate distances
   * - Sort stores by distance
   * - Rebuild the listings
   * - Adjust the map camera
   * - Open a popup for the closest store
   * - Highlight the listing for the closest store.
   */
  geocoder.on('result', (event) => {
    /* Get the coordinate of the search result */
    const searchResult = event.result.geometry;

    /**
     * Calculate distances:
     * For each store, use turf.disance to calculate the distance
     * in miles between the searchResult and the store. Assign the
     * calculated value to a property called `distance`.
     */
    const options = { units: 'miles' };
    for (const store of stores.features) {
      store.properties.distance = turf.distance(searchResult, store.geometry, options);
    }

    /**
     * Sort stores by distance from closest to the `searchResult`
     * to furthest.
     */
    stores.features.sort((a, b) => {
      if (a.properties.distance > b.properties.distance) {
        return 1;
      }
      if (a.properties.distance < b.properties.distance) {
        return -1;
      }
      return 0; // a must be equal to b
    });

    /**
     * Rebuild the listings:
     * Remove the existing listings and build the location
     * list again using the newly sorted stores.
     */
    const listings = document.getElementById('listings');
    while (listings.firstChild) {
      listings.removeChild(listings.firstChild);
    }
    buildLocationList(stores);

    /* Open a popup for the closest store. */
    createPopUp(stores.features[0]);

    /** Highlight the listing for the closest store. */
    const activeListing = document.getElementById(`listing-${stores.features[0].properties.id}`);
    activeListing.classList.add('active');

    /**
     * Adjust the map camera:
     * Get a bbox that contains both the geocoder result and
     * the closest store. Fit the bounds to that bbox.
     */
    const bbox = getBbox(stores, 0, searchResult);
    map.fitBounds(bbox, {
      padding: 100,
    });
  });
});

/**
 * Using the coordinates (lng, lat) for
 * (1) the search result and
 * (2) the closest store
 * construct a bbox that will contain both points
 */
function getBbox(sortedStores, storeIdentifier, searchResult) {
  const lats = [sortedStores.features[storeIdentifier].geometry.coordinates[1], searchResult.coordinates[1]];
  const lons = [sortedStores.features[storeIdentifier].geometry.coordinates[0], searchResult.coordinates[0]];
  const sortedLons = lons.sort((a, b) => {
    if (a > b) {
      return 1;
    }
    if (a.distance < b.distance) {
      return -1;
    }
    return 0;
  });
  const sortedLats = lats.sort((a, b) => {
    if (a > b) {
      return 1;
    }
    if (a.distance < b.distance) {
      return -1;
    }
    return 0;
  });
  return [
    [sortedLons[0], sortedLats[0]],
    [sortedLons[1], sortedLats[1]],
  ];
}

/**
 * Add a marker to the map for every store listing.
 **/
function addMarkers() {
  /* For each feature in the GeoJSON object above: */
  for (const marker of stores.features) {
    /* Create a div element for the marker. */
    const el = document.createElement('div');
    /* Assign a unique `id` to the marker. */
    el.id = `marker-${marker.properties.id}`;
    /* Assign the `marker` class to each marker for styling. */
    el.className = 'marker';

    /**
     * Create a marker using the div element
     * defined above and add it to the map.
     **/
    new mapboxgl.Marker(el, { offset: [0, -23] }).setLngLat(marker.geometry.coordinates).addTo(map);

    /**
     * Listen to the element and when it is clicked, do three things:
     * 1. Fly to the point
     * 2. Close all other popups and display popup for clicked store
     * 3. Highlight listing in sidebar (and remove highlight for all other listings)
     **/
    el.addEventListener('click', (e) => {
      flyToStore(marker);
      createPopUp(marker);
      const activeItem = document.getElementsByClassName('active');
      e.stopPropagation();
      if (activeItem[0]) {
        activeItem[0].classList.remove('active');
      }
      const listing = document.getElementById(`listing-${marker.properties.id}`);
      listing.classList.add('active');
    });
  }
}

/**
 * Add a listing for each store to the sidebar.
 **/
function buildLocationList(stores) {
  for (const store of stores.features) {
    /* Add a new listing section to the sidebar. */
    const listings = document.getElementById('listings');
    const listing = listings.appendChild(document.createElement('div'));
    /* Assign a unique `id` to the listing. */
    listing.id = `listing-${store.properties.id}`;
    /* Assign the `item` class to each listing for styling. */
    listing.className = 'item';

    /* Add the link to the individual listing created above. */
    const link = listing.appendChild(document.createElement('a'));
    link.className = 'title';
    link.id = `link-${store.properties.id}`;
    link.innerHTML = `${store.properties.storeName}`;

    /* Add details to the individual listing. */
    const details = listing.appendChild(document.createElement('div'));
    if (store.properties.address) {
      details.innerHTML += `${store.properties.address}`;
    }
    if (store.properties.distance) {
      const roundedDistance = Math.round(store.properties.distance * 100 * 1.60934) / 100;
      details.innerHTML += `<div><strong>${roundedDistance} km away</strong></div>`;
    }
    // details.innerHTML += `<a class="info" href="${store.properties.articleUrl}">More information</a>`

    /**
     * Listen to the element and when it is clicked, do four things:
     * 1. Update the `currentFeature` to the store associated with the clicked link
     * 2. Fly to the point
     * 3. Close all other popups and display popup for clicked store
     * 4. Highlight listing in sidebar (and remove highlight for all other listings)
     **/
    link.addEventListener('click', function () {
      for (const feature of stores.features) {
        if (this.id === `link-${feature.properties.id}`) {
          flyToStore(feature);
          createPopUp(feature);
        }
      }
      const activeItem = document.getElementsByClassName('active');
      if (activeItem[0]) {
        activeItem[0].classList.remove('active');
      }
      this.parentNode.classList.add('active');
    });
  }
}

/**
 * Use Mapbox GL JS's `flyTo` to move the camera smoothly
 * a given center point.
 **/
function flyToStore(currentFeature, isCenter = false) {
  let addY = 0.0042;
  // mobile
  if (window.innerWidth < 1080) {
    addY = 0.003;
  }

  const config = {
    center: [currentFeature.geometry.coordinates[0], currentFeature.geometry.coordinates[1] + addY],
    zoom: 15,
  };

  if (isCenter) {
    config['center'] = [currentFeature.geometry.coordinates[0], currentFeature.geometry.coordinates[1]];
  }
  map.flyTo(config);
}

/**
 * Create a Mapbox GL JS `Popup`.
 **/
function createPopUp(currentFeature) {
  const popUps = document.getElementsByClassName('mapboxgl-popup');
  if (popUps[0]) popUps[0].remove();
  let deliveryHTML = '';
  currentFeature.properties.delivery.forEach(function (delivery) {
    let icon = iconUrls[delivery.app];
    let iconHover = iconUrls[delivery.app + 'Hover'];
    deliveryHTML += `
      <a class="app-btn-link" href="${delivery.url}" target="_blank">
        <div class="${delivery.app} app-btn">
            <img class="non-hover-img" src="${icon}">
            <img class="hover-img" src="${iconHover}">
        </div>
      </a>
    `;
  });
  const hours = currentFeature.properties.openingHours;
  let openingHTML = `<div class="opening-hours">
    <h4>Opening Hours</h4>
      <div class="day">
        <div class="dayname">Mon:</div>
        <div class="daytime">${hours.mon}</div>
      </div>
      <div class="day">
        <div class="dayname">Tue:</div>
        <div class="daytime">${hours.tue}</div>
      </div>
      <div class="day">
        <div class="dayname">Wed:</div>
        <div class="daytime">${hours.wed}</div>
      </div>
      <div class="day">
        <div class="dayname">Thu:</div>
        <div class="daytime">${hours.thu}</div>
      </div>
      <div class="day">
        <div class="dayname">Fri:</div>
        <div class="daytime">${hours.fri}</div>
      </div>
      <div class="day">
        <div class="dayname">Sat:</div>
        <div class="daytime">${hours.sat}</div>
      </div>
      <div class="day">
        <div class="dayname">Sun:</div>
        <div class="daytime">${hours.sun}</div>
      </div>
    </div>
  </div>`;

  const popup = new mapboxgl.Popup({ closeOnClick: true, anchor: 'bottom' })
    .setLngLat(currentFeature.geometry.coordinates)
    .setHTML(
      `
      <div class="left-side">
        <h3>${currentFeature.properties.storeName}</h3>
        <p>${currentFeature.properties.address}</p>
        <a style="color: #FFB81C; font-size: 15px; padding-left: 0px; margin-bottom: 10px; display: block;" href=${
          currentFeature.properties.articleUrl
        }>more info<a>
        ${deliveryHTML}
      </div>
      <div class="right-side">
        ${currentFeature.properties.closed.length ? `<div>Temporarily Closed</div>` : openingHTML}
      </div>
      `
    )
    .addTo(map);

  // Add GTM tracking to delivery platform links
  setTimeout(function() {
    const deliveryLinks = document.querySelectorAll('.mapboxgl-popup .app-btn-link');
    deliveryLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        const platform = this.querySelector('.app-btn').className.split(' ')[0];

        // Google Tag Manager tracking
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'delivery_platform_click',
          'platform': platform,
          'store_name': currentFeature.properties.storeName,
          'store_address': currentFeature.properties.address
        });
        console.log('TEST:: GTM event fired - delivery_platform_click', platform);
      });
    });
  }, 100);

  popup.on('close', function () {
    flyToStore(currentFeature, true);
  });
}
